<script lang="ts">
    import ProgressBar from "./ProgressBar.svelte";
    import {onMount} from "svelte";
    import {ProgressUtil} from "../../progress";
    import {CategoryModel} from "../../models/CategoryModel";

    export let category: CategoryModel;
    export let answers: any;
    let progress = 57;


    onMount(async () => {
        const {total, current} = ProgressUtil.getProgressByCategory(category, answers);
        progress = current / total * 100;
    });
</script>

<ProgressBar progress="{progress}" calculatedProgress="{true}" showPercentage="{true}"/>
